module.exports = __webpack_public_path__ + "static/img/wdht.cc9a63d2.png";